import React from "react";
import DeleteModal from "../../../components/DeleteModal";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { deletePackageRequest } from "../../../store/Packages/actions";
function PackagesDelete({
  setDeleteModal,
  deleteMessage,
  deletePackage,
  id,
  isOpen
}) {
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(deletePackageRequest(id));
    setDeleteModal({ id: 0, isOpen: false });
  };
  return (
    <DeleteModal
      deleteMessage={deleteMessage}
      deleteTitle={deletePackage}
      isOpen={isOpen}
      handleDelete={handleDelete}
      handleCancel={() => setDeleteModal({ id: 0, isOpen: false })}
    />
  );
}
PackagesDelete.propTypes = {
  id: PropTypes.any,
  setDeleteModal: PropTypes.func,
  deleteMessage: PropTypes.string,
  deletePackage: PropTypes.string,
  isOpen: PropTypes.bool
};
export default PackagesDelete;
